"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import { useList } from '../../../../hooks/useList.mjs';
import { ContextMenu } from '../../../../../ContextMenu/ContextMenu.mjs';
import '../../../../../MenuItem/MenuItem.mjs';
import { ContextMenuTrigger } from '../../../../../ContextMenu/components/ContextMenuTrigger/ContextMenuTrigger.mjs';
import 'react-aria-components';
import '../../../../../ContextMenu/components/ContextMenuSection/ContextMenuSection.mjs';
import locales from '../../../../../../../../_virtual/_.locale.json@8d5024994f97657f895a4e2a188d2d8a.mjs';
import ButtonView from '../../../../../../views/ButtonView.mjs';
import 'react';
import '@tabler/icons-react';
import '../../../../../Icon/Icon.mjs';
import '../../../../../../lib/viewComponentContext/viewComponentContext.mjs';
import { IconSettings } from '../../../../../Icon/components/icons/IconSettings.mjs';
import HeadingView from '../../../../../../views/HeadingView.mjs';
import { useLocalizedStringFormatter } from 'react-aria';
import headerStyles from '../../Header.module.css.mjs';
import { ViewModeMenuItem } from './ViewModeMenuItem.mjs';
import { useAvailableViewModes } from '../../lib.mjs';
import { SortingMenuItem } from './SortingMenuItem.mjs';
import SeparatorView from '../../../../../../views/SeparatorView.mjs';
import ContextMenuSectionView from '../../../../../../views/ContextMenuSectionView.mjs';

const SettingsMenu = () => {
  const list = useList();
  const selectedViewMode = list.viewMode;
  const availableViewModes = useAvailableViewModes();
  const viewModeItems = availableViewModes.map((viewMode) => /* @__PURE__ */ jsx(ViewModeMenuItem, { viewMode }, viewMode));
  const sortingItems = list.visibleSorting.map((s) => /* @__PURE__ */ jsx(SortingMenuItem, { sorting: s }, s.id));
  const labelSorting = list.visibleSorting.find((s) => s.isSorted());
  const stringFormatter = useLocalizedStringFormatter(locales);
  if (sortingItems.length === 0 && viewModeItems.length <= 1) {
    return null;
  }
  return /* @__PURE__ */ jsxs(ContextMenuTrigger, { children: [
    /* @__PURE__ */ jsx(
      ButtonView,
      {
        className: headerStyles.mobile,
        variant: "outline",
        color: "secondary",
        "aria-label": stringFormatter.format("list.settings"),
        children: /* @__PURE__ */ jsx(IconSettings, {})
      }
    ),
    /* @__PURE__ */ jsxs(ContextMenu, { children: [
      viewModeItems.length > 1 && /* @__PURE__ */ jsxs(
        ContextMenuSectionView,
        {
          selectionMode: "single",
          selectedKeys: [selectedViewMode],
          children: [
            /* @__PURE__ */ jsx(HeadingView, { children: stringFormatter.format("list.settings.viewMode") }),
            viewModeItems
          ]
        }
      ),
      sortingItems.length > 0 && viewModeItems.length > 1 && /* @__PURE__ */ jsx(SeparatorView, {}),
      sortingItems.length > 0 && /* @__PURE__ */ jsxs(
        ContextMenuSectionView,
        {
          selectionMode: "single",
          selectedKeys: labelSorting ? [labelSorting.id] : [],
          children: [
            /* @__PURE__ */ jsx(HeadingView, { children: stringFormatter.format("list.sorting") }),
            sortingItems
          ]
        }
      )
    ] })
  ] });
};

export { SettingsMenu };
//# sourceMappingURL=SettingsMenu.mjs.map
